'use client'
import { useEffect } from 'react'

import { PUBLIC_GA_TRACKING_ID } from '@/shared/constants'
import { usePathname } from 'next/navigation'
import { analyticsPageview, tagPageview } from '@/app/libs/gtm'
import useOnMouseAndScroll from '@/shared/hooks/useOnMouseAndScroll'

function GoogleAnalytics() {
  const pathname = usePathname()
  const { isLoaded } = useOnMouseAndScroll()

  useEffect(() => {
    if (isLoaded) {
      const e = document.createElement('script')
      e.async = true
      e.src = `https://www.googletagmanager.com/gtag/js?id=${PUBLIC_GA_TRACKING_ID}`
      document.head.appendChild(e)
      e.onload = () => {
        const sc = document.createElement('script')
        sc.innerHTML = `
				window.dataLayer = window.dataLayer || [];
				function gtag(){dataLayer.push(arguments);}
				gtag('js', new Date());
				console.log()
				gtag('config', '${PUBLIC_GA_TRACKING_ID}');
			`
        document.head.appendChild(sc)
      }
    }
  }, [isLoaded])

  useEffect(() => {
    if (window.gtag) {
      analyticsPageview(pathname)
    }
    tagPageview(pathname)
  }, [pathname])
  return <></>
}
export default GoogleAnalytics
